import { showWhetherLiked } from "./liking.js";

export async function loadMoreSketches(liked = undefined, isPublic=false) {
    const loader = document.getElementById("sketch-loader");
    // Nothing to do if there are no more sketches
    if (!loader) {
        return;
    }
    if (loader.dataset.hasNext !== "true") {
        return;
    }
    // Prevent multiple simultaneous requests
    if (loader.dataset.loading === "true") {
        return;
    }
    loader.dataset.loading = "true";

    const cursor = loader.dataset.nextCursor;
    const params = new URLSearchParams();

    const artistFilter = document.getElementById('artistFilter');
    const characterFilter = document.getElementById('characterFilter');
    const bookmarkedFilter = document.getElementById('bookmarked-filter');
    const artist = artistFilter.value === "" ? undefined : artistFilter.value;
    const character = characterFilter.value === "" ? undefined : characterFilter.value;

    if (cursor) {
        params.set("after", cursor);
        if(artist){
            params.append("artist", artist);
        }
        if(character){
            params.append("character", character);
        }
        if(isPublic){
            params.append("p", "1");
        }
        if(bookmarkedFilter && bookmarkedFilter.checked){
            params.append("bookmarked", "true");
        }
    }

    try {
        const response = await fetch(
            `/sketch_cards?${params.toString()}`
        );

        if (!response.ok) {
            throw new Error(
                `Failed loading sketches: ${response.status}`
            );
        }
        // This is another full sketch_list.html response
        const html = await response.text();

        // Convert returned HTML string into DOM nodes
        const temp = document.createElement("div");
        temp.innerHTML = html;

        if (liked) {
            temp.querySelectorAll(".like-button").forEach(btn => {
                showWhetherLiked(btn, liked);
            });
        }

        // Grab only the new cards
        const newRow = temp.querySelector(".row");
        const currentRow = document.querySelector(
            "#sketch-results .row"
        );

        if (newRow && currentRow) {
            currentRow.insertAdjacentHTML(
                "beforeend",
                newRow.innerHTML
            );
        }

        // Grab updated cursor information
        const newLoader = temp.querySelector(
            "#sketch-loader"
        );

        if (newLoader) {
            loader.dataset.nextCursor =
                newLoader.dataset.nextCursor;

            loader.dataset.hasNext =
                newLoader.dataset.hasNext;
        }
    } catch (error) {
        console.error(
            "Unable to load more sketches",
            error
        );

    } finally {
        loader.dataset.loading = "false";
    }
}